import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { IKeywordElement } from './models/keyword-elements'
import { KeywordApp } from './components/keyword-app';
import { createRoot } from 'react-dom/client';


const keywordMount = document.getElementById('keyword-app');

if (keywordMount) {
    const root = createRoot(keywordMount); 
    const title = (window as any).bootstrap.keywordTitle;
    const searchButtonText = (window as any).bootstrap.keywordSearchButtonText;
    const keywordItems = (window as any).bootstrap.keywordItems as IKeywordElement[];

    root.render(
        <KeywordApp
            title={title}
            searchButtonText={searchButtonText}
            items={keywordItems}
            
        />);
}